// extracted by css-extract-rspack-plugin
export default {"notes":"common__notes--S5f51","notesOther":"common__notesOther--53G7B","annotation":"common__annotation--UpByS","textLabel":"common__textLabel--PN7bw"};